export const stripExtension = (name: string) => name.replace(/\.[a-z0-9]+$/i, "")
